export default "__VITE_ASSET__DWeIYSzO__"